var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"items-amount-counter",style:(_vm.counterStyles)},[_c('counter-tag',[_vm._v(_vm._s(_vm.amount))]),(_vm.isNeedReview)?_c('need-review-circle'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }